import { Component, OnInit, Input } from '@angular/core';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-selected-work-packages',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './selected-work-packages.component.html',
  styleUrl: './selected-work-packages.component.css'
})
export class SelectedWorkPackagesComponent implements OnInit {
  /**
   * Angular uses unidirectional data flow, so if the parent’s data changes, the child will automatically update
   * 
   * ! symbol informs TypeScript compiler that the variable or property will definitely be assigned
   *  a value before it is accessed, even though it might not look that way during compilation.
   *  So it suppresses the error because it guarantees the property will be initialized.
   */
  @Input() inputData!: { eoiId: number; projectId: number; tenderingSubType: string };
  selectedWorkPackages: any;

  constructor(
    private tenderingService: TenderingService,
    private cdr : ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.fetchSelectedWorkPackages();
  }

  /**
   * Tendering shared component
   */
  fetchSelectedWorkPackages() {
    return this.tenderingService.fetchModuleSelectedWorkPackages(
      this.inputData.eoiId,
      this.inputData.projectId,
      this.inputData.tenderingSubType
    ).subscribe({
      next: (response: any) => {
        if (response?.data?.selected_work_packages) {
          this.selectedWorkPackages = response?.data?.selected_work_packages;
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }


}
